import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {BaseService} from '@nh/angular-tses';
import {environment} from 'environments/environment';
import {catchError, map} from 'rxjs/operators';

export interface DepartureReasonCodes {
  id?: string;
  departureId: string;
  createdBy?: string;
  createdAt?: number;
  approximateCreatedAt?: boolean;
  reasonCodes: string[];
  recommendation: boolean;
}

export interface ReasonCode {
  id: string;
  description: string;
  type: string;
  subType?: string;
  category?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ReasonCodeService extends BaseService {
  constructor(protected _snackbar: MatSnackBar, private _httpClient: HttpClient) {
    super(_snackbar);
    this.getAll().then(result => {
      this.reasonCodes = result;
    });
  }
  public static readonly REASON_CODES_ENDPOINT: string = `${environment.tsesConfig.apiHost}/reasonCode/reasons`;

  public reasonCodes: ReasonCode[];

  public getAll(): Promise<ReasonCode[]> {
    if (this.reasonCodes && this.reasonCodes.length > 0) {
      return Promise.resolve(this.reasonCodes);
    }

    return this._httpClient
      .get(ReasonCodeService.REASON_CODES_ENDPOINT)
      .pipe(
        map((res: ReasonCode[]) => res),
        catchError((err: any) => {
          this._handleError(err, 'Failed to get reason code list. Please contact the DAS team.');
          return [];
        })
      )
      .toPromise();
  }

  public get(...ids: string[]): Promise<ReasonCode[]> {
    return this.getAll().then(allReasonCodes => {
      const reasonCodes: ReasonCode[] = [];
      ids.forEach(id => {
        const reasonCode: ReasonCode = allReasonCodes.find(rc => id === rc.id);
        if (reasonCode) {
          reasonCodes.push(reasonCode);
        }
      });
      return reasonCodes;
    });
  }
}
